/**
 * Test if a provided object is an HTMLElement
 *
 * @param object Object to test
 */
export const isHtmlElement = (object) => object instanceof HTMLElement;
/**
 * Test if a provided object is a DocumentFragment
 * @param object Object to test
 */
export const isDocumentFragment = (object) => object instanceof DocumentFragment;
/**
 * Test if a provided object is Mediatable
 *
 * @param obj Object to test
 */
export const isMediatable = (obj) => typeof obj === 'object' && 'mediate' in obj;
/**
 * Test if a provided object is a catalog item
 *
 * @param obj Object to test
 */
export const isCatalogItem = (obj) => {
    if (typeof obj === 'object') {
        return 'init' in obj && 'isElementAvailable' in obj && 'getElement' in obj;
    }
    if (typeof obj === 'function') {
        return 'init' in obj.prototype && 'isElementAvailable' in obj.prototype && 'getElement' in obj.prototype;
    }
    return false;
};
/**
 * Test if a provided object is a Jsx Component
 *
 * @param obj Object to test
 */
// Would prefer to do 'obj instanceof JsxComponent' here, but it
// causes unresolvable circular dependencies
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isJsxCatalogItem = (obj) => 'createElement' in obj;
/**
 * Test if a provided object is Registerable
 *
 * @param obj Object to test
 */
export const isRegisterable = (obj) => typeof obj === 'object' && 'registerable' in obj && !!obj.registerable;
/**
 * Test if a provided object is Toggleable
 *
 * @param obj Object to test
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isToggleable = (obj) => 'toggle' in obj;
/**
 * Test if a provided argument is an Text Node
 *
 * @param object Object to test
 */
export const isTextNode = (object) => object instanceof Text;
